import { Popover, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import No_UpComingBookingsIcon from "@/Components/Icons/NoData/No_UpComingBookingsIcon";
import RunningLateIcon from "@/Components/Icons/RunningLateIcon";
import { UpcomingBookingSkeleton } from "@/Components/Skeletons/client/UpcomingBookingSkeleton";
import { routingConstants } from "@/Constants/routingConstants";
import {
  fetchUpcomingBookings,
  setUpcomingBookingsLoading,
  toggleShowUpcomingBookingViewModal,
  updateUpcomingBookingsAsync,
} from "@/reducers/clientdashboard";

import ContractInfoPopup from "./ContractInfoPopup";
import LiverTImerForUpcomingShifts from "./LiverTImerForUpcomingShifts";
import { TOOLTIPTEXT } from "../../../../utilities/CommonText";
import { showRoleAccessToast } from "../../../../utilities/utils";
import ExpandIcon from "../../../Icons/chat/ExpandIcon";
import PublishBookedContractDurationIcon from "../../../Icons/PublishBookedContractDurationIcon";
import DashboardUpcomingBookingModal from "../../../modals/DashboardUpcomingBookingModal";

/**
 * Fetches upcoming bookings and sets loading state.
 *
 * @param {void} - No parameters
 * @return {void} - No return value
 */
export const UpcomingBookings = () => {
  const dispatch = useDispatch();
  const { upcomingBookings, upcomingBookingsLoading } = useSelector(
    (state) => state.clientDashboard,
  );
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );

  const bookingColor = {
    "0%": "#FF0000",
    "50%": "#0000ff",
    "100%": "#00ff00",
  };
  /**
   * Fetches upcoming bookings and sets the loading state.
   *
   * @param None
   * @return Promise
   */
  useEffect(() => {
    dispatch(setUpcomingBookingsLoading(true));
    dispatch(
      fetchUpcomingBookings({
        for_upcomming: 0,
      }),
    );
  }, []);

  const POLLING_INTERVAL = 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(updateUpcomingBookingsAsync());
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  /**
   * A function that generates a JSX element containing the name, role, route ID, and ongoing status.
   *
   * @param {type} _name - description of parameter
   * @param {type} _role - description of parameter
   * @param {type} _route_id - description of parameter
   * @param {type} _is_ongoing - description of parameter
   * @return {type} JSX element representing the name, role, route ID, and ongoing status
   */

  const runningLateIconUi = () => {
    return (
      <div className="cursor-pointer pt-[3px]">
        <RunningLateIcon cls={"text-red"} />
      </div>
    );
  };
  const getName_Role = (
    _name,
    _role,
    _route_id,
    _is_ongoing,
    _running_late_status,
    _is_time_started,
  ) => {
    return (
      <div className="flex w-full items-center">
        <div className="grow overflow-hidden">
          {!clientUserAllPermissions ||
          clientUserAllPermissions.is_allow_to_view_candidate_profile === 1 ? (
            <>
              <Link
                to={routingConstants.candidateDetail(_route_id)}
                className="line-clamp-1 text-base font-semibold leading-[normal] text-black"
              >
                {_name}
              </Link>
            </>
          ) : (
            <span className="line-clamp-1 cursor-default text-base font-semibold leading-[normal] text-black">
              {_name}
            </span>
          )}
        </div>
        <span
          className={`px-2 py-1 text-[12px] font-semibold ${_running_late_status ? "bg-red-200 text-red" : _is_ongoing ? "bg-green-200 text-green" : _is_time_started ? "bg-yellow-200 text-yellow" : "bg-lightblue text-primary"} flex min-h-[24px] min-w-[73px] items-center justify-center rounded-[4px]`}
        >
          {_role}
        </span>
      </div>
    );
  };
  if (!upcomingBookingsLoading && upcomingBookings.length == 0) {
    return (
      <div className="UpcomingBookings_Wrapper">
        <div className="flex h-[283px] flex-col items-center justify-center rounded-[10px] bg-white shadow-[0px_1px_8px_0px_#E7EFFB]">
          <No_UpComingBookingsIcon />
          <span className="text-[18px] font-semibold leading-[normal] text-primary">
            No Upcoming Booking
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="UpcomingBookings_Wrapper tour-dashboard-upcoming-booking">
      <div className="rounded-[10px] bg-white p-4 shadow-[0px_1px_8px_0px_#E7EFFB]">
        <div className="mb-[15px] flex items-center justify-between">
          <h3 className="!text-[18px] !font-bold !leading-[normal] text-black">
            {upcomingBookings.some((item) => item.is_ongoing == 1)
              ? "Upcoming / Ongoing Bookings"
              : "Upcoming Bookings"}
          </h3>
          {upcomingBookings.length > 5 && !upcomingBookingsLoading ? (
            <Tooltip title={TOOLTIPTEXT?.viewAllUpcomingShifts} placement="top">
              <button
                // to={routingConstants.bookedCandidate}
                className={`transition-linear flex gap-1 text-base font-medium text-primary hover:!text-primaryActive ${!clientUserAllPermissions || clientUserAllPermissions?.is_allow_to_booked_list ? "cursor-pointer" : "cursor-not-allowed opacity-50"}`}
                onClick={() => {
                  if (
                    !clientUserAllPermissions ||
                    clientUserAllPermissions?.is_allow_to_booked_list
                  ) {
                    dispatch(toggleShowUpcomingBookingViewModal(true));
                  } else {
                    showRoleAccessToast();
                    return;
                  }
                }}
                aria-label="expand button"
              >
                <ExpandIcon cls={"text-primary"} />
              </button>
            </Tooltip>
          ) : null}
        </div>
        <DashboardUpcomingBookingModal />
        <div className="grid grid-cols-1 gap-[16px] md:grid-cols-2 xl:grid-cols-3 xl:gap-[22px]">
          {upcomingBookingsLoading ? (
            <>
              <UpcomingBookingSkeleton />
              <UpcomingBookingSkeleton />
              <UpcomingBookingSkeleton />
            </>
          ) : (
            upcomingBookings.map((item, index) => {
              const {
                profile_image,
                role_name,
                contract_date,
                candidate_name,
                contract_start_time,
                contract_end_time,
                candidate_email,
                mobile_phone_number,
                profile_percent,
                contract_duration,
                break_time,
                licence_no,
                contract_ref_no,
                route_contract_id,
                is_ongoing,
                route_id,
                running_late_status = false,
                candidate_id,
                running_late_reason,
                is_time_started,
                logged_in_time,
              } = item;
              const contract_date_formatted =
                moment(contract_date).format("ddd DD") +
                " <br/> " +
                moment(contract_date).format("MMM");
              const breakTime = moment(break_time, "HH:mm:ss").format("mm");
              let breakTimeSTR = "";
              if (breakTime === "00") {
                breakTimeSTR = "No Break";
              } else {
                breakTimeSTR = `${breakTime} min break`;
              }
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  content={
                    <ContractInfoPopup
                      key={index}
                      data={{
                        contract_ref_no,
                        contract_date_formatted,
                        contract_duration,
                        candidate_name,
                        profile_image,
                        role_name,
                        licence_no,
                        profile_percent,
                        contract_start_time,
                        contract_end_time,
                        mobile_phone_number,
                        candidate_email,
                        breakTimeSTR,
                        route_id, // candidate detail route
                        route_contract_id, // contract detail route
                        candidate_id,
                        logged_in_time,
                      }}
                    />
                  }
                >
                  <div
                    className={`${running_late_status ? "border border-red" : is_ongoing ? "border-2 border-green" : is_time_started ? "border-2 border-yellow-500" : "border border-[#E9F1FD]"} grid cursor-pointer grid-cols-[79px,1fr] overflow-hidden rounded-lg`}
                  >
                    <div
                      className={`min-h-[83px] ${running_late_status ? "bg-red-200 text-red" : is_ongoing ? "bg-green-200 text-green" : is_time_started ? "bg-yellow-200 text-yellow" : "bg-[#E9F1FD] text-primary"} flex items-center justify-center`}
                    >
                      <span
                        className="text-center text-[16px] font-semibold lg:text-[18px]"
                        dangerouslySetInnerHTML={{
                          __html: contract_date_formatted,
                        }}
                      ></span>
                    </div>
                    <div className="flex grow flex-col items-start justify-start gap-[2px] p-[8px_12px_7px]">
                      {getName_Role(
                        candidate_name,
                        role_name,
                        route_id,
                        is_ongoing,
                        running_late_status,
                        is_time_started,
                      )}
                      <div className="flex w-full justify-between">
                        <div className="flex grow flex-col">
                          <span className="w-fit font-normal text-txtColor">
                            {moment(contract_start_time, "HH:mm:ss").format(
                              "HH:mm",
                            )}{" "}
                            -{" "}
                            {moment(contract_end_time, "HH:mm:ss").format(
                              "HH:mm",
                            )}
                          </span>
                          {!clientUserAllPermissions ||
                          clientUserAllPermissions.is_allow_to_view_contract_detail ===
                            1 ? (
                            <>
                              <Link
                                to={routingConstants.contractDetail(
                                  route_contract_id,
                                )}
                                className="w-fit text-[12px] font-normal text-primary"
                              >
                                {contract_ref_no}
                              </Link>
                            </>
                          ) : (
                            <span className="w-fit cursor-default text-[12px] font-normal text-primary">
                              {contract_ref_no}
                            </span>
                          )}
                          {/* <Link
                            to={routingConstants.contractDetail(route_contract_id)}
                            className="text-[12px] font-normal text-primary"
                          >
                            {contract_ref_no}
                          </Link> */}
                        </div>
                        {running_late_status ? (
                          <Popover
                            trigger={"hover"}
                            content={
                              <>
                                <div className="flex w-[300px] items-center justify-between rounded-lg p-5 text-black">
                                  <p className="text-[14px] font-medium">
                                    {candidate_name} is running late for shift -
                                    Reason:
                                    <span className="font-bold">
                                      {" "}
                                      {running_late_reason}{" "}
                                    </span>
                                  </p>
                                </div>
                              </>
                            }
                          >
                            {!clientUserAllPermissions ||
                            clientUserAllPermissions.is_allow_to_view_contract_detail ? (
                              <>
                                <Link
                                  to={routingConstants.contractDetail(
                                    route_contract_id,
                                  )}
                                  className="w-fit cursor-pointer text-[12px] font-normal text-primary"
                                >
                                  {runningLateIconUi()}
                                </Link>
                              </>
                            ) : (
                              runningLateIconUi()
                            )}
                          </Popover>
                        ) : is_ongoing ? (
                          <>
                            <Tooltip
                              // title="The candidate's clock-in time"
                              title={`${candidate_name} started shift at ${moment(logged_in_time).format("HH:mm")}`}
                            >
                              <div className="flex items-center gap-1">
                                <PublishBookedContractDurationIcon
                                  cls={"text-green"}
                                />
                                <span className="text-base font-medium text-green">
                                  {moment(logged_in_time).format("HH:mm")}
                                </span>
                              </div>
                            </Tooltip>
                          </>
                        ) : is_time_started ? (
                          <LiverTImerForUpcomingShifts
                            contractDate={contract_date}
                            contractStartTime={contract_start_time}
                            contractEndTime={contract_end_time}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </Popover>

                // </Popover>
              );
            })
          )}
        </div>
        {/* <div className="flex justify-center mt-[7px]">
          {!isLoading ? (
            <Link
              to={route("client.booked_candidate")}
              className="w-[24px] h-[24px] bg-none text-primary grid place-items-center"
            >
              <DownArrowIcon />
            </Link>
          ) : null}
        </div> */}
      </div>
    </div>
  );
};
